import React from 'react'

const Rewards = () => {
  return <h2>Rewards Management</h2>
}

export default Rewards
